import { useState } from "react";

import displayToast from "@common/components/Toast/displayToast";
import { setWorkspacesAction } from "@main/context/App/App.actions";
import { useAppContext, useAppDispatch } from "@main/context/App/App.context";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";

import { useAdministrationDeps } from "../Administration";

export default function useExtensionsViewApiConsumer() {
  const { administrationService } = useAdministrationDeps();
  const { selectedWorkspace } = useAppSelectionContext();
  const { workspaces } = useAppContext();
  const appDispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const disableSentry = async () => {
    try {
      if (!selectedWorkspace) throw new Error();
      setLoading(true);

      await administrationService.disconnectSentry(selectedWorkspace.id);

      const updatedWorkspaces = workspaces.map((w) =>
        w.id === selectedWorkspace.id ? { ...w, sentry: undefined } : w,
      );
      appDispatch(setWorkspacesAction(updatedWorkspaces));

      displayToast({ content: "Sentry has been disabled" });
      return true;
    } catch (error) {
      displayToast({ title: "Something went wrong", content: "There was an error while disabling Sentry" });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    disableSentry,
    selectedWorkspace,
    loading,
  };
}
